import { UNSAFE_noExposureExp } from '@confluence/feature-experiments';

export const getCohortValue = () => {
	const [expConfig] = UNSAFE_noExposureExp('confluence_recommend_trial_to_free_ab');
	return expConfig.get<string>('cohort', 'not-enrolled');
};
